// extracted by mini-css-extract-plugin
export var editor = "_1a-0";
export var flowSidebar = "_4a-2";